module.exports = __webpack_public_path__ + "static/media/pauseIcon.835ebe7e.svg";